module.exports = __webpack_public_path__ + "static/img/in-class.26d2b967.png";